module.exports = __webpack_public_path__ + "static/img/Jeremy_McGovern_mobile.9cfb964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_McGovern_mobile.jpg
// module id = N5z/
// module chunks = 0